import { Inject, Injectable } from "@angular/core";
import { WindowToken } from "@app/util/window.token";
import { DOCUMENT } from "@angular/common";

@Injectable({ providedIn: "root" })
export class PrintService {

    constructor(@Inject(WindowToken) private $window: Window,
                @Inject(DOCUMENT) private $document: Document ) { }

    print(title: string, reason: string): void {
        this.$window.print();
    }
}


